module.exports = __webpack_public_path__ + "static/img/图片9.5d659806.png";